// A paid receipt can cover a deposit without paying the whole appointment.
export function appointmentPayment(appointment) {
    const total = Math.round(Number(appointment?.price || 0) * 100);
    const receipt = appointment?.payment || {};
    const paid = ['paid', 'partiallypaid'].includes(String(receipt.status || '').toLowerCase())
        ? Math.round(Number(receipt.amount || 0) * 100) : 0;
    const outstanding = Math.max(0, total - paid);
    return {paid: paid / 100, outstanding: outstanding / 100,
        label: outstanding === 0 ? 'Paid' : paid > 0 ? 'Part paid' : 'Pending'};
}
